import {ValueObject} from '@s-ui/domain'

export class InitPaymentRequestTransactionsValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.passcode
   * @param {Object} data.tradeId
   */
  #passcode
  #tradeId

  constructor({passcode, tradeId}) {
    super()
    this.#passcode = passcode
    this.#tradeId = tradeId
  }

  getPasscode = () => this.#passcode

  getTradeId = () => this.#tradeId

  static create = ({passcode, tradeId}) => {
    return new InitPaymentRequestTransactionsValueObject({passcode, tradeId})
  }

  toJSON = () => {
    return {
      passcode: this.#passcode,
      tradeId: this.#tradeId
    }
  }
}
